import React, { useState, useCallback } from "react";
import Gallery from "react-photo-gallery";
import Carousel, { Modal, ModalGateway } from "react-images";
import { imageBaseURL } from "../../utils/fetchData";
const GalleryPart = ({ data }) => {
  const [imageData, setIageData] = useState(data || {});
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);
  const [photos, setPhotos] = useState([]);
  const [photos2, setPhotos2] = useState([]);
  React.useEffect(() => {
    if (imageData?.data?.attributes?.Gallery?.data?.length > 0) {
      const data = [];
      imageData?.data?.attributes?.Gallery?.data?.map((obj) => {
        if (obj?.attributes)
          data.push({
            src:
              imageBaseURL +
              (obj?.attributes?.formats?.thumbnail?.url ||
                obj?.attributes?.url),
          });
      });
      setPhotos(data);
    }
  }, [imageData]);
  React.useEffect(() => {
    if (imageData?.data?.attributes?.Gallery?.data?.length > 0) {
      const data = [];
      imageData?.data?.attributes?.Gallery?.data?.map((obj) => {
        if (obj?.attributes)
          data.push({
            src: imageBaseURL + obj?.attributes?.url,
          });
        else data.push({ src: imageBaseURL + obj?.attributes?.url });
      });
      setPhotos2(data);
    }
  }, [imageData]);
  console.log("testing16.......", photos, photos2);
  const openLightbox = useCallback((event, { photo, index }) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  }, []);

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  return (
    <>
      <div className="rs-gallery pb-30 md-pt-80 md-pb-50">
        <div className="container">
          <Gallery  direction={"row"} photos={photos} onClick={openLightbox} />
          <ModalGateway>
            {viewerIsOpen ? (
              <Modal onClose={closeLightbox}>
                <Carousel
                  currentIndex={currentImage}
                  views={photos2?.map((x) => ({
                    ...x,
                    srcset: x.srcSet,
                    caption: x.title,
                  }))}
                />
              </Modal>
            ) : null}
          </ModalGateway>
        </div>
      </div>
    </>
  );
};

export default GalleryPart;
